import { getClient } from "Globals/api";
import { LRUMap } from "Utils/lruMap";

const nonScopeHeaders = [ 
    "account", "organisation", "origin", "resourceGroup" 
];

const cacheKeyFns = [
    headers => headers.project,
    headers => headers.instance,
    headers => headers.account,
    headers => headers.organisation,
    headers => headers.document,
    headers => headers.heading,
];

const createSelector = (cacheKeyFnsArg, fn) => {
    const cache = new LRUMap(10);
    const cacheKeyFn = arg => cacheKeyFnsArg.map(i => `${i(arg)}`).join("-");
    return arg => {
        const key = cacheKeyFn(arg);
        if(cache.get(key)) {
            return cache.get(key); 
        }
        const r = fn(key, arg);
        cache.set(key,r);
        return r;
    };
};

// TODO: get all possible contexts pseudo-dynamically here
const selectClient = createSelector(
    cacheKeyFns,
    () => getClient()
);

export const injectBoundGQLClient = (fn, mdContext = {}) => {
    return (...args) => {
        const clientPromise = selectClient(mdContext);
        const headersfromaction = {
            ...Object.fromEntries(
                Object.entries(mdContext).map(([ header, val ]) => [ `x-${nonScopeHeaders.includes(header) ? header : `scope-${header}`}`, val, ])
            ),
        };
        const wrappedClient = {
            query: (query, ...options) => clientPromise.then(client => client.query({
                ...query,
                variables: {
                    ...headersfromaction,
                    ...query.variables
                },
                context: {
                    ...query.context,
                    headers: {
                        ...(query.headers || {}),
                        ...headersfromaction
                    }
                }
            }, ...options)),
            mutate: (mutation, ...options) => clientPromise.then(client => client.mutate({
                ...mutation,
                variables: {
                    ...headersfromaction,
                    ...mutation.variables
                },
                context: {
                    ...mutation.context,
                    headers: {
                        ...(mutation.headers || {}),
                        ...headersfromaction
                    }
                },
            }, ...options)),
            subscribe: (subscription, ...options) => clientPromise.then(client => client.subscribe({
                ...subscription,
                variables: {
                    ...headersfromaction,
                    ...subscription.variables
                },
                context: {
                    ...subscription.context,
                    headers: {
                        ...(subscription.headers || {}),
                        ...headersfromaction
                    }
                }
            }, ...options)),
        };
        const callargs = [ ...args, { client: wrappedClient } ]; 
        return fn(...callargs);
    };
};
